<template>
  <div class="card">
    <div class="card-header">
      <h3>Số liệu lời nhắn</h3>
    </div>
    <div class="dang-ky">
      <b-row>
        <b-col lg="4">
          <a :href="linkLoiNhanMoi" target="_blank">
            <div class="dang-ky__new">
              <h5>Mới</h5>
              <div class="dang-ky__content">{{ moi }}</div>
            </div>
          </a>
        </b-col>

        <b-col lg="4">
          <a :href="linkLoiNhanDangXuLy" target="_blank">
            <div class="dang-ky__inprocess">
              <h5>Đang xử lý</h5>
              <div class="dang-ky__content">{{ dang_xu_ly }}</div>
            </div>
          </a>
        </b-col>

        <b-col lg="4">
          <a :href="linkLoiNhanDaXuLy" target="_blank">
            <div class="dang-ky__ok">
              <h5>Đã xử lý</h5>
              <div class="dang-ky__content">{{ da_xu_ly }}</div>
            </div>
          </a>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import mushroom from "viettoc-api";
export default {
  data() {
    return {
      moi: 0,
      dang_xu_ly: 0,
      da_xu_ly: 0,
      linkLoiNhanMoi: "",
      linkLoiNhanDangXuLy: "",
    };
  },
  methods: {
    fn_getLink() {
      this.linkLoiNhanMoi =
        location.origin +
        "/admin/loi-nhan/danh-sach-loi-nhan?&filters=trang_thai%3Dmoi";
      this.linkLoiNhanDangXuLy =
        location.origin +
        "/admin/loi-nhan/danh-sach-loi-nhan?&filters=trang_thai%3Ddang_xu_ly";
      this.linkLoiNhanDaXuLy =
        location.origin +
        "/admin/loi-nhan/danh-sach-loi-nhan?&filters=trang_thai%3Dda_xu_ly";
    },
    async fn_thongKe() {
      try {
        const response_moi = await mushroom.ldp_loi_nhan.listAsync(
          {
            fields:
              "id,ho_ten,dien_thoai,email,noi_dung,loai_loi_nhan,trang_thai,file_dinh_kem,thoi_diem_tao",
            filters: ["trang_thai=moi"],
            limit: 1,
          },
          { cacheAge: 1 }
        );
        if (response_moi.result) {
          this.moi = response_moi.meta.total;
        } else this.moi = 0;

        const response_dang_xu_ly = await mushroom.ldp_loi_nhan.listAsync(
          {
            fields:
              "id,ho_ten,dien_thoai,email,noi_dung,loai_loi_nhan,trang_thai,file_dinh_kem,thoi_diem_tao",
            filters: ["trang_thai=dang_xu_ly"],
            limit: 1,
          },
          { cacheAge: 1 }
        );
        if (response_dang_xu_ly.result) {
          this.dang_xu_ly = response_dang_xu_ly.meta.total;
        } else this.dang_xu_ly = 0;

        const response_da_xu_ly = await mushroom.ldp_loi_nhan.listAsync(
          {
            fields:
              "id,ho_ten,dien_thoai,email,noi_dung,loai_loi_nhan,trang_thai,file_dinh_kem,thoi_diem_tao",
            filters: ["trang_thai=da_xu_ly"],
            limit: 1,
          },
          { cacheAge: 1 }
        );
        if (response_da_xu_ly.result) {
          this.da_xu_ly = response_da_xu_ly.meta.total;
        } else this.da_xu_ly = 0;
      } catch (e) {
        console.error("Có lỗi: %o", e);
      }
    },
  },
  async created() {
    this.fn_getLink();
    await this.fn_thongKe();
  },
};
</script>

<style lang="scss">
a {
  text-decoration: none;
}
.box-style {
  border-radius: 10px;
  color: #fff;
}
.dang-ky {
  a {
    text-decoration: none;
  }
  padding: 20px;
  h5 {
    padding: 10px;
    border-bottom: 1px solid #ffffff;
    text-align: center;
  }
  &__ok,
  &__new,
  &__await,
  &__cancel,
  &__inprocess {
    @extend .box-style;
  }
  &__new,
  &__inprocess {
    margin: 5px 0;
  }
  &__content {
    padding: 15px;
    font-size: 40px;
    font-weight: 600;
    text-align: center;
  }
  &__new {
    background: #409eff;
  }
  &__ok {
    background: #67c23a;
  }
  &__inprocess {
    background: #3cc;
  }
  &__cancel {
    background: #f56c6c;
  }
}
@media (min-width: 992px) {
  .dang-ky__new,
  .dang-ky__inprocess {
    margin: unset;
  }
}
</style>
